export type LegalDocumentId = "service" | "privacy" | "terms";

export interface LegalDocument {
    id: LegalDocumentId;
    title: string;
    subtitle?: string;
    link: string;
}

export const LEGAL_DOCUMENTS: readonly LegalDocument[] = [
    {
        id: "service",
        title: "Licença de uso e Termos de Serviços do VSaúde",
        link: "https://stvsaudeprd.blob.core.windows.net/public/licenca-uso-termos-servicos.pdf",
    },
    {
        id: "privacy",
        title: "Política de Tratamento de Dados",
        link: "https://stvsaudeprd.blob.core.windows.net/public/politica-tratamento-dados.pdf",
    },
    {
        id: "terms",
        title: "Termo Padrão de Consentimento às Políticas de Tratamento de Dados",
        subtitle: "Termo de Consentimento às Políticas de Tratamento de Dados",
        link: "https://stvsaudeprd.blob.core.windows.net/public/termo-consentimento-politica-tratamento-dados.pdf",
    },
];

export function getLegalDocument(id: string): LegalDocument {
    return LEGAL_DOCUMENTS.find((document) => document.id === id);
}
